"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmwareUpdateStatus = void 0;
var FirmwareUpdateStatus;
(function (FirmwareUpdateStatus) {
    /**
     * The server is downloading the firmware
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["DOWNLOADING"] = 0] = "DOWNLOADING";
    /**
     * The server is waiting for the tracker to be rebooted by the user
     * Note that is is not the same as REBOOTING
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["NEED_MANUAL_REBOOT"] = 1] = "NEED_MANUAL_REBOOT";
    /**
     * The server tries to authenticate with the MCU
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["AUTHENTICATING"] = 2] = "AUTHENTICATING";
    /**
     * The server is uploading the firmware to the Device
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["UPLOADING"] = 3] = "UPLOADING";
    /**
     * The serial flasher tries to sync with the MCU
     * You can use this event to prompt the user to press the boot btn
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["SYNCING_WITH_MCU"] = 4] = "SYNCING_WITH_MCU";
    /**
     * The MCU is rebooting
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["REBOOTING"] = 5] = "REBOOTING";
    /**
     * The server is provisioning the tracker
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["PROVISIONING"] = 6] = "PROVISIONING";
    FirmwareUpdateStatus[FirmwareUpdateStatus["DONE"] = 7] = "DONE";
    /**
     * Could not find the device
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["ERROR_DEVICE_NOT_FOUND"] = 8] = "ERROR_DEVICE_NOT_FOUND";
    /**
     * The operation timed out, > 1min
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["ERROR_TIMEOUT"] = 9] = "ERROR_TIMEOUT";
    /**
     * The firmware download failed
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["ERROR_DOWNLOAD_FAILED"] = 10] = "ERROR_DOWNLOAD_FAILED";
    /**
     * The server could not authenticate with the MCU
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["ERROR_AUTHENTICATION_FAILED"] = 11] = "ERROR_AUTHENTICATION_FAILED";
    /**
     * Could not upload the firmware to the MCU
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["ERROR_UPLOAD_FAILED"] = 12] = "ERROR_UPLOAD_FAILED";
    /**
     * The provision of the tracker failed, usually wifi credentials
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["ERROR_PROVISIONING_FAILED"] = 13] = "ERROR_PROVISIONING_FAILED";
    /**
     * An unsupported Flashing method was used
     */
    FirmwareUpdateStatus[FirmwareUpdateStatus["ERROR_UNSUPPORTED_METHOD"] = 14] = "ERROR_UNSUPPORTED_METHOD";
    FirmwareUpdateStatus[FirmwareUpdateStatus["ERROR_UNKNOWN"] = 15] = "ERROR_UNKNOWN";
})(FirmwareUpdateStatus = exports.FirmwareUpdateStatus || (exports.FirmwareUpdateStatus = {}));
